<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="wrap_body">
      <div class="center">
        <div class="ucenter_main">
          <ucMenu num="5"></ucMenu>
          <div class="right_con">
            <div class="rc_main">
              <p class="fb">抖店优化</p>
              <div class="operate-box">
                <el-select v-model="activeMerShopId" placeholder="请选择店铺" class="shop-select" @change="changeShop">
                  <el-option v-for="shop in shopList" :key="shop.mer_shop_id" :label="shop.shop_name" :value="shop.mer_shop_id"></el-option>
                </el-select>
                <div>
                  <span class="hosting-label">AI生图/主图视频托管</span>
                  <el-switch v-model="videoHostingEnabled"  @change="handleVideoHostingChange"></el-switch>
                </div>
                <el-button type="primary" size="small" class="record-btn" @click="openImgRecord">AI生图/主图视频优化记录</el-button>
                <div>
                  <el-button type="primary" plain size="small" class="title-host-btn" @click="changeTitle">标题自动化托管</el-button>
                  <div class="status-tag" :class="{'red':seo_open_status!=2}">标题托管：{{seo_open_status==2?'已开启':'未开启'}}</div>
                </div>

              </div>
              <div class="low-effect-box">
                <el-tabs v-model="suggestion" @tab-click="handleSearchSuggestion">
                  <el-tab-pane label="建议下架" name="suggest_offline"></el-tab-pane>
                  <el-tab-pane label="强制下架" name="force_offline"></el-tab-pane>
                  <el-tab-pane label="高潜力品" name="optimize"></el-tab-pane>
                </el-tabs>
                <template v-if="['suggest_offline','force_offline'].includes(suggestion)">
                  <div class="d-b-c">
                    <el-button size="mini" type="primary" plain :disabled="!checkListLowEffect.length" @click="batchOffSaleSelected">批量下架<span
                        v-if="checkListLowEffect.length">（选中{{ checkListLowEffect.length }}件）</span></el-button>
                    <el-button size="mini" @click="handleSearchSuggestion"><i class="el-icon-refresh-right el-icon--right"></i>刷新</el-button>
                  </div>
                  <el-tag type="warning" style="margin-top: 10px;">若商品上架后连续多天未获得有效曝光，可能会被系统自动下架，以释放流量给更优质的商品。</el-tag>
                </template>
                <template v-else>
                  <div class="d-b-c">
                    <div></div>
                    <el-button size="mini" @click="handleSearchSuggestion"><i class="el-icon-refresh-right el-icon--right"></i>刷新</el-button>
                  </div>
                </template>
                <!-- 商品列表表格 -->
                <el-table ref="diagnosistTable" v-loading="lowLoading" :data="diagnosisList"
                          :header-cell-style="{ background: '#eef1f6', color: '#606266' }" class="diagnosis-table"
                          empty-text="暂无低效商品" @select="handleSelect" @select-all="handleSelectAll">
                  <el-table-column type="selection" width="50">
                  </el-table-column>
                  <el-table-column label="商品" min-width="300">
                    <template #default="{ row }">
                      <div class="goods-info-wrap">
                        <el-image :src="row.main_url" style="width: 48px;height: 48px;border-radius: 6px;"></el-image>
                        <div class="goods-info">
                          <p class="goods-name">{{ row.product_name }}</p>
                          <p class="goods-sku">ID:{{ row.product_id }}</p>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="诊断结果" width="200">
                    <template #default="{ row }">
                      <div :class="row.suggestion" class="result-badge"  v-if="['suggest_offline','force_offline'].includes(suggestion)">
                        <i :class="row.suggestion === 'force_offline' ? 'el-icon-error' : 'el-icon-info'"></i>
                        {{ row.suggestion === 'force_offline' ? '强制下架' : '建议下架' }}
                      </div>
                      <div v-if="row.suggestion_reason" class="result-hint">
                        <template v-if="row.suggestion_reason.indexOf('opt_white_pic')>-1||row.suggestion_reason.indexOf('opt_mvideo')>-1">
                          <div v-if="row.suggestion_reason=== 'opt_white_pic'">没有白色底图</div>
                          <div v-if="row.suggestion_reason=== 'opt_mvideo'">没有主图视频</div>
                        </template>
                        <div style="color: #ed5959" v-else-if="row.suggestion_reason.indexOf('duplicate')>-1&&suggestion==='suggest_offline'">重复品</div>
                        <span v-else> {{ row.suggestion_reason }}</span>
                       </div>

                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="200">
                    <template #default="{ row }">
                      <el-button type="danger" size="small"
                                 @click="handleOffSale(row)"  v-if="['suggest_offline','force_offline'].includes(suggestion)">
                        {{row?.suggestion_reason?.indexOf('duplicate')>-1&&suggestion==='suggest_offline'?'一键':''}}下架
                      </el-button>
                      <template v-if="suggestion === 'optimize'">
                      <el-button type="success" plain size="small" @click="handleWhitePic" style="margin: 4px 0;" v-if="row.suggestion_reason.indexOf('opt_white_pic')>-1">生成白色底图</el-button>
                      <el-button type="success" plain size="small" @click="handleMvideo" style="margin-left: 0;" v-if="row.suggestion_reason.indexOf('opt_mvideo')>-1">生成主图视频</el-button>
                      </template>
                    </template>
                  </el-table-column>
                </el-table>

                <Pagination :limit.sync="lowPageData.page_size" :page-sizes="[20,50,100,200,500]"
                            :page.sync="lowPageData.page_no"
                            :total="lowPageData.total" layout="total, sizes, prev, pager, next, jumper"
                            @pagination="getShopProductSuggestionList"/>
                <!-- 底部操作栏 -->
                <div v-if="diagnosisList.length > 0" class="bottom-bar">
                  <span class="selected-count">已选择 {{ checkListLowEffect.length }} 件商品</span>
                  <div class="bottom-actions">
                    <el-button :disabled="!checkListLowEffect.length" size="small" type="primary"
                               @click="batchOffSaleSelected">批量下架选中
                    </el-button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <myFoot></myFoot>
    <div id="huhu"></div>
<!--    <Bixi :data="componentConfig"/>-->
  </div>
</template>

<script>

import {
  mapActions,
  mapState
} from "vuex";
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import {Bixi} from '@open-fxg/bixi-vue'
import Pagination from "@/components/pagination/pagination.vue";

export default {
  name: "ucenterDdHost",
  data() {
    return {
      shopList: [],
      huhu: {componentId: 502,},
      currentShop: {},
      report: null,
      reportObj: {},
      // 低效商品相关
      componentConfig: {
        componentId: 524,
      },//ecopen.bixi组件渲染
      openLoading: false,
      authShopList: [],
      oldMerShopId:'',
      activeMerShopId: '',
      activeAutoShop: {},
      lowPageData: {page_no: 1, page_size: 20, total: 0},
      suggestion: 'suggest_offline',//商品处理建议
      lowLoading: false,
      diagnosisList: [],
      checkAllLowEffect: false,
      checkListLowEffect: [],
      videoHostingEnabled:0,
      seo_open_status:0
    }
  },
  components: {
    Pagination,
    myHead,
    myFoot,
    ucMenu,
    Bixi
  },
  computed: {},
  created() {
    this.getAuthShopList()
  },
  destroyed() {
    this.shopList.forEach(shop => {
      window.ecopen?.__internal_destroy_multi_tea__?.(shop.mer_shop_id)
    })
  },
  methods: {
    ...mapActions({
      fetchSingleShopInfo: 'index/fetchSingleShopInfo',
      fetchAuthSuccessShopList: 'ucenter/fetchAuthSuccessShopList',
      fetchShopProductSuggestionList: 'ucenter/fetchShopProductSuggestionList',
      fetchSeoTrusteeshipStrategy: 'ucenter/fetchSeoTrusteeshipStrategy',
      fetchShopHostingInfo: 'ucenter/fetchShopHostingInfo',
      updateMaterialHosting: 'ucenter/updateMaterialHosting',
      opCleanOffline: 'ucenter/opCleanOffline',
    }),
    getAuthShopList() {
      this.fetchAuthSuccessShopList({
        success: (res) => {
          this.shopList=res.data
          this.changeShop(this.shopList[0].mer_shop_id)
        }
      })
    },
   async changeShop(e){
      if(this.oldMerShopId){
        window.ecopen?.__internal_destroy_multi_tea__?.(this.oldMerShopId)
      }
      this.oldMerShopId = this.activeMerShopId
      this.activeMerShopId =e
      this.getHostStatus()
     this.getSeoHostStatus()

     // 1. 关闭自动弹窗
      const data = await this.getToken(this.activeMerShopId)
      window.ecopen.start({
        token: data.token.token,
        appId: data.appId,
        shopId: data.shopId,
        blockedDistributeComponents: [502,509,508]
      })

     this.initReport()
     this.handleSearchSuggestion()
    },
    //获取标题托管状态
    getSeoHostStatus(){
      this.fetchSeoTrusteeshipStrategy({
        data: {
          mer_shop_id: this.activeMerShopId
        },
        success: (res) => {
          this.seo_open_status = res?.data?.open_status??0
        }
      })

    },
    //获取主图视频托管状态
    getHostStatus(){
      this.fetchShopHostingInfo({
        data: {
          mer_shop_id: this.activeMerShopId
        },
        success: (res) => {
          this.videoHostingEnabled = res?.data?.is_true??false
        }
      })
    },
    getToken(merShopId) {
      return new Promise((resolve) => {
        const ecopenConfigMult = localStorage.getItem('ecopenConfigMult') ? JSON.parse(localStorage.getItem('ecopenConfigMult')) : {}
        const ecopenConfig = ecopenConfigMult[merShopId] ? ecopenConfigMult[merShopId] : {}
        const now = new Date().getTime()
        if (!ecopenConfig.token || ecopenConfig.token.expire_time * 1000 < now) {
          this.fetchSingleShopInfo({
            data: {mer_shop_id: merShopId},
            success: (res) => {
              ecopenConfigMult[merShopId] = res.data
              localStorage.setItem('ecopenConfigMult', JSON.stringify(ecopenConfigMult))
              resolve(res.data)
            }
          })
        } else {
          resolve(ecopenConfig)
        }
      })
    },

    // 曝光、点击事件上报
    initReport() {
      /**
       * 1. 创建实例
       * @param shop_id string
       * @returns report function
       */
      this.report = window.ecopen.__internal_multi_tea__(this.activeMerShopId);
      const nameArr = [1, 6, 7, 2, 3, 4]
      nameArr.forEach(name => {
        this.handleReport('block_view', name)
      })
    },
    handleReport(eventName, name) {
      try {
        /**
         * 2. 上报事件
         * @param eventName string 埋点事件
         * @param params Record<string, any> 事件参数
         */
        const params = {
          terminal: 'open',
          shop_id: this.activeMerShopId,
          page_name: '杭州云网电子商务有限公司_商品诊断与优化_open',
          name: name
        }
        const report = this.report
        report(eventName, params)
      } catch (error) {
        console.log(error)
      }
    },

    handleVideoHostingChange(val) {
      this.handleReport('bu_general_click', 6)
      this.handleReport('bu_general_click', 7)
      const params={
        mer_shop_id:this.activeMerShopId,
        status:val?1:2 //1开启 2关闭
      }
      this.updateMaterialHosting({
        data: params,
        success: (res) => {
          if (res.code == 200) {
            this.videoHostingEnabled=val
            this.$message.success(val ? '已开启AI生图/主图视频托管' : '已关闭AI生图/主图视频托管')
          }else{
            this.videoHostingEnabled=!val
            this.$message.error(res.message)
          }
        }
      })
    },
    //标题托管
    async changeTitle() {
      this.handleReport('bu_general_click', 1)
        // 2. 手动触发
        window.ecopen.bixi(document.getElementById('huhu'), {
          componentId: 502,
          onClose: () => {
            this.getSeoHostStatus()
          },
          extra: {},
        });
    },
    //打开AI生图/主图视频优化记录
    async openImgRecord() {
        // 2. 手动触发
        window.ecopen.bixi(document.getElementById('huhu'), {
          componentId: 509,
          extra: {},
        });
    },
    // === 建议下架列表 ===
    handleSearchSuggestion() {
      this.lowPageData.page_no = 1
      this.checkListLowEffect=[]
      this.getShopProductSuggestionList()
    },
    getShopProductSuggestionList() {
      const params = {
        mer_shop_id: this.activeMerShopId,
        suggestion: this.suggestion,
        page_no: this.lowPageData.page_no,
        page_size: this.lowPageData.page_size
      }
      this.lowLoading = true
      this.fetchShopProductSuggestionList({
        data: params,
        success: (res) => {
          if (res.code === 200) {
            this.diagnosisList = res.data.product_list || []
            this.lowPageData.total = res.data.total || 0
            this.$nextTick(() => {
              const rows = this.diagnosisList.filter(item => this.checkListLowEffect.includes(item.product_id))
              rows.forEach(row => {
                this.$refs.diagnosistTable.toggleRowSelection(row);
              });
            })
            // 更新警告信息
            // this.warningInfo.expired_count = this.diagnosisList.filter(item => item.diagnosis_type === 'expired').length
          }
          this.lowLoading = false
        }
      })

    },
    // el-table 全选处理
    handleSelectAll(selection) {
      const arr = selection.map(i => {
        return i.product_id
      })
      const allArr = this.diagnosisList.map(i => {
        return i.product_id
      })
      this.checkListLowEffect = selection && selection.length ? [...new Set([...this.checkListLowEffect, ...arr])] : this.checkListLowEffect.filter(i => !allArr.includes(i));

    },
    // el-table 单选处理
    handleSelect(selection, row) {
      const index = this.checkListLowEffect.indexOf(row.product_id)
      if (index >= 0) {
        this.checkListLowEffect = this.checkListLowEffect.filter(i => i != row.product_id)
      } else {
        this.checkListLowEffect.push(row.product_id)
      }
    },
    // 单个商品下架(一键下架isMulti=true)
    handleOffSale(item) {
      this.$confirm(`确认下架商品「${item.product_name}」吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.cleanOfflineFun(item.product_id)
      }).catch(() => {
      })
    },
    // 批量下架选中
    batchOffSaleSelected() {
      if (this.checkListLowEffect.length === 0) {
        this.$message.warning('请先选择商品')
        return
      }
      this.$confirm(`确认下架选中的 ${this.checkListLowEffect.length} 件商品吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const ids = this.checkListLowEffect.join(',')
        this.cleanOfflineFun(ids)

      }).catch(() => {
      })
    },
    cleanOfflineFun(ids){
      const params = {
        mer_shop_id:this.activeMerShopId,
        product_ids:ids
      }
      this.opCleanOffline( {
        data: params,
        success: (res) => {
          if(res.code === 200){
            this.$message.success('下架成功')
            this.handleSearchSuggestion()
          }else {
            this.$message.error(res.message)
          }
        }
      })
    },
    //生成白色底图
    handleWhitePic(){
      this.handleReport('bu_general_click', 4)
      // 2. 手动触发
      window.ecopen.bixi(document.getElementById('huhu'), {
        componentId: 508,
        extra: {
          batchMaterialInfos:'no_white_bg_pic',
          // 传入的商品字符串列表，用英文逗号分割
          // productIds?: string;
        },
      });
    },

    //生成主图视频
    handleMvideo(){
      this.handleReport('bu_general_click', 2)
      this.handleReport('bu_general_click', 3)
      // 2. 手动触发
      window.ecopen.bixi(document.getElementById('huhu'), {
        componentId: 508,
        extra: {
          batchMaterialInfos:'pic_11_not_full,pic_34_not_full'
        },
      });
    }

  },
}
</script>

<style scoped>
.wrap .wrap_body {
  display: flex;
  flex-direction: column;
}

.center {
  display: flex;
  flex: 1;
}

.rc_main {
  padding: 36px 40px 46px;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box; /* 确保 padding 不会撑大容器宽度，防止溢出 */

}
.d-b-c{
  display: flex;justify-content: space-between;align-items: center;
}

/* 低效商品诊断样式 */
.low-effect-box {
  margin-top: 20px;
}

.diagnosis-table {
  margin-top: 10px;
  margin-bottom: 16px;
}

.goods-info-wrap {
  display: flex;
  gap: 12px;
}

.goods-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.goods-name {
  font-size: 13px;
  color: #303133;
  margin: 0;
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.result-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
}

.result-badge.force_offline {
  background: #fff2f0;
  color: #ff4d4f;
}

.result-badge.suggest_offline {
  background: #fff7e6;
  color: #faad14;
}

.result-hint {
  font-size: 12px;
  color: #909399;
  margin: 0;
}

.table-row .col-action {
  flex: 0 0 180px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.table-empty {
  text-align: center;
  padding: 40px;
  color: #909399;
  font-size: 14px;
}

.bottom-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #f5f7fa;
  margin-top: 10px;
  border-radius: 4px;
}

.selected-count {
  font-size: 13px;
  color: #606266;
}

.bottom-actions {
  display: flex;
  gap: 12px;
}

/* 操作栏样式 */
.operate-box {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 16px 20px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  margin: 20px 0;
}

.shop-select {
  width: 200px;
}

.title-host-btn {
  background: #1890ff;
  border-color: #1890ff;
  color: #fff;
}

.status-tag {
  display: inline-block;
  font-size: 12px;
  line-height: 28px;
  padding: 0 12px;
  background: #e6f7ff;
  color: #1890ff;
  border-color: #91d5ff;
  margin-left: 4px !important;
  margin-top: 2px;
}
.status-tag.red{
  color: red;
}

.hosting-label {
  font-size: 14px;
  color: #606266;
  margin-right: 4px;
}

.hosting-status {
  font-size: 14px;
  color: #606266;
}

.record-btn {
  background: #1890ff;
  border-color: #1890ff;
}

.shop-list {
  margin-top: 20px;
  gap: 10px;
}

.shop-item {
  width: 100%;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
}

.shop-item-info {
  display: flex;
  align-items: center;
}

.shop-item-info .shop-logo {
  width: 50px;
  height: 50px;
  margin-right: 15px;
}

.hosting-switches {
  display: flex;
  gap: 10px;
}

.hosting-switches .switch-label {
  color: #666666;
  font-size: 14px;
  margin-right: 4px;
}

</style>

